module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BMe7cE/CoverDesign.jpg?1684514755880",
      "alt": "This image is the cover for the book The Supers, Dreamspun Beyond"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Supers, Dreamspun Beyond\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("The Supers")])])]), _c('p', [_vm._v("Hunting ghosts and finding more than they bargained for.")]), _vm._v(" "), _c('p', [_vm._v("Blaine Franks is a member of the paranormal research group the Supernatural Explorers. When the group loses their techie to a cross-country move, newly graduated Flynn Huntington gets the job. Flynn fits in with the guys right off the bat, but when it comes to him and Blaine, it’s more than just getting along.")]), _vm._v(" "), _c('p', [_vm._v("Things heat up between Blaine and Flynn as they explore their first haunted building, an abandoned hospital, together. Their relationship isn’t all that progresses, though, and soon it seems that an odd bite on Blaine’s neck has become much more.")]), _vm._v(" "), _c('p', [_vm._v("Hitchhiking ghosts, a tragic love story forgotten by time, and the mystery of room 204 round out a romance where the things that go bump in the night are real.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sean Michael\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0